import { render } from "./driver-details.vue?vue&type=template&id=36b0c586&scoped=true"
import script from "./driver-details.vue?vue&type=script&lang=js"
export * from "./driver-details.vue?vue&type=script&lang=js"

import "./driver-details.vue?vue&type=style&index=0&id=36b0c586&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b0c586"]])

export default __exports__